import { render } from "./TripleList.vue?vue&type=template&id=44b38804&scoped=true"
import script from "./TripleList.vue?vue&type=script&lang=js"
export * from "./TripleList.vue?vue&type=script&lang=js"

import "./TripleList.vue?vue&type=style&index=0&id=44b38804&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44b38804"

export default script